import auth from 'services/Auth';

const useHasLeaderBoard = () => {
  let hasLeaderBoard = false;

  const isOpteamTeamLeader = auth.user.organizationRoleCode.includes('OPTEAM_LEADER');
  const isLeader = auth.user.organizationRoleCode.includes('LEADER');
  const isCoach = auth.user.organizationRoleCode.includes('COACH');

  if (isLeader || isOpteamTeamLeader || isCoach) {
    hasLeaderBoard = true;
  }

  return hasLeaderBoard;
};

export default useHasLeaderBoard;
